<template>
  <div class="w-screen h-screen flex items-center justify-center">
    <Spinner :size="28" />
  </div>
</template>

<script setup lang="ts">
import Spinner from '@/shared/components/Spinner.vue'
import { useValidateOtpMutation } from '@/shared/graphql/legacy/generated'
import { onBeforeMount } from 'vue'
import { parseQuery, useRouter } from 'vue-router'

const { mutate: validateOTP } = useValidateOtpMutation()

const router = useRouter()

onBeforeMount(async () => {
  const searchParams = parseQuery(window.location.search)

  await validateOTP({
    code: searchParams.ott as string,
  })

  router.push('/auth/success')
})
</script>
